module.exports = __webpack_public_path__ + "static/media/md-desktop.8e16a894.svg";